import { FhsAxios } from "../../services/axios";

export default {
  state: {
    userContact: []
  },
  actions: {
    sendPhoneNumberToContact({ getters }, phoneNumber) {
      return new Promise((resolve, reject) => {
        FhsAxios.post("user/call-me", {
          // Значение "2" означает, что отправляется номер пользователя, введеный в поле ввода. При значении "1" телефон пользователя для связи берется из базы данных
          phoneType: "2",
          phoneCustom: phoneNumber
        })
          .then(response => {
            resolve(response);
          })
          .catch(e => {
            reject(e);
          });
      });
    },
    fetchContact({ commit, getters }) {
      FhsAxios.post("contacts/get-contacts", {}).then(response => {
        commit("setUserContact", response.data.result.contacts);
      });
    }
  },
  mutations: {
    setUserContact(state, userContact) {
      state.userContact = userContact;
    },
    unsetUserContact(state) {
      state.userContact = [];
    }
  },
  getters: {
    userContact(state) {
      return state.userContact;
    }
  }
};
